import React, { useState, useEffect } from 'react';
import { Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography, Pagination, Card, Button, LinearProgress, TextField } from '@mui/material';
import toast from 'react-hot-toast';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import LeadService from '../../core/services/leadsService';
import dayjs from 'dayjs';
// import { format } from 'date-fns';
const PromoDateMessage = ({ GetAllPrompts, getMessageTime, open, setOpen,morning_Time, afternoon_Time,isMorningDisabled,isEveningDisabled,setIsMorningDisabled,setIsEveningDisabled,agentID}) => {
    const parseTimeString = (timeString) => {
        if (!timeString) return null; // Return null if there's no valid time string
        const [hours, minutes, seconds] = timeString.split(':').map(Number);
        const date = dayjs(); // Use dayjs for time management
        return date.hour(hours).minute(minutes || 0).second(seconds || 0);
    };
    const [morningTime, setMorningTime] = useState(morning_Time ? parseTimeString(morning_Time) : null);
    const [eveningTime, setEveningTime] = useState(afternoon_Time ? parseTimeString(afternoon_Time) : null);
    const [Loading, setLoading] = useState(false);

    useEffect(() => {
        if (morning_Time) setMorningTime(parseTimeString(morning_Time));
        if (afternoon_Time) setEveningTime(parseTimeString(afternoon_Time));
    }, [morning_Time, afternoon_Time]);

    const handleMorningChangeTime = (newTime) => {
        if (newTime) {
            setMorningTime(newTime); // newTime will be a valid Date object
        }
    };

    const handleEveningChangeTime = (newTime) => {
        if (newTime) {
            setEveningTime(newTime); // newTime will be a valid Date object
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
        setIsEveningDisabled(false);
        setIsMorningDisabled(false);
    };

    const formatTimeForBackend = (time) => {
        if (!time) return null;
        const hours = time.hour(); // Get hours in 24-hour format (0-23)
        const minutes = time.minute(); // Get minutes (in case you want to send minutes too)

        // Return time in 24-hour format "HH:mm"
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    };

    const handleSaveTime = async () => {
        try {
            if (!morningTime) {
                toast.error('Morning time is required');
                return;
            } else if (!eveningTime) {
                toast.error('Evening time is required');
                return;
            }

            // Validate that morning time is before evening time
            if (morningTime.isAfter(eveningTime)) {
                toast.error('Morning time must be before evening time');
                return;
            }

            setLoading(true);

            // Format times for the backend
            const formattedMorningTime = formatTimeForBackend(morningTime);
            const formattedEveningTime = formatTimeForBackend(eveningTime);

            // Call your service to save the times
            const res = await LeadService.UpdateTimeSetting(formattedMorningTime, formattedEveningTime,agentID);
            if (res.data.success) {
                toast.success(res.data.message);
                setOpen(false);
                GetAllPrompts();
                getMessageTime();
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Button
                onClick={handleOpen}
                variant="contained"
                className='main-primary-btn'
            >
                Select Time Agent
            </Button>
            <Modal open={open}>
                <Box
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: '#fff',
                        padding: '20px',
                        borderRadius: '10px',
                        width: '558px',
                        height: 'auto',
                    }}
                    className="modal-resp-settings"
                >
                    <Box style={{ display: 'flex' }}>
                        <Typography
                            style={{
                                fontSize: '18px',
                                color: '#252F46',
                                fontWeight: '700',
                            }}
                        >
                            Select Time Agent
                        </Typography>
                    </Box>
                    <IconButton style={{ position: 'absolute', top: '10px', right: '10px' }} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                    <Box>
                        <Box style={{ display: 'grid', gap: '20px', marginTop: '15px' }}>
                            <Box style={{ display: 'grid', marginBottom: '10px' }}>
                                <Typography style={{ fontWeight: 'bold' }}>Morning Time</Typography>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['TimePicker']}>
                                        <TimePicker
                                            // label="Morning Time"
                                            value={morningTime}
                                            onChange={handleMorningChangeTime}
                                            ampm // Enable AM/PM format
                                            views={['hours']}
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{
                                                width: '100%',
                                                overflow: 'hidden',
                                                '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                },
                                                '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                },'& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                },
                                            }}
                                            inputFormat="h a" // Format for display in input (e.g., '9 AM')
                                            disabled={isEveningDisabled}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Box>

                            <Box style={{ display: 'grid' }}>
                                <Typography style={{ fontWeight: 'bold' }}>Evening Time</Typography>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['TimePicker']}>
                                        <TimePicker
                                            // label="Evening Time"
                                            value={eveningTime}
                                            onChange={handleEveningChangeTime}
                                            ampm // Enable AM/PM format
                                            views={['hours']}
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{
                                                width: '100%',
                                                overflow: 'hidden',
                                                '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                },
                                                '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                },'& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                },
                                            }}
                                            inputFormat="h a" // Format for display in input (e.g., '9 PM')
                                            disabled={isMorningDisabled}

                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Box>
                        </Box>
                        <Box style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            <Box>
                                <Button
                                    onClick={handleSaveTime}
                                    style={{
                                        width: '148px',
                                        height: '43px',
                                        backgroundColor: '#5379BD',
                                        color: 'white',
                                        borderRadius: '8px',
                                        textTransform: 'capitalize',
                                        fontSize: 'auto',
                                    }}
                                    sx={{ fontFamily: 'inherit',}}
                                >
                                    {' '}
                                    {Loading ? 'Saving...' : 'Save'}
                                </Button>
                                <LinearProgress sx={{ visibility: Loading ? '' : 'hidden' }} />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

export default PromoDateMessage;
